import { render, staticRenderFns } from "./Loan.vue?vue&type=template&id=53862e12&scoped=true"
import script from "./Loan.vue?vue&type=script&lang=js"
export * from "./Loan.vue?vue&type=script&lang=js"
import style0 from "./Loan.vue?vue&type=style&index=0&id=53862e12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53862e12",
  null
  
)

export default component.exports